<template>
  <section v-if="content" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Communities</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">
      Members per community<span v-if="content.community_total_members"> ({{ content.community_total_members }} total)</span>.
    </p>

    <div v-if="communities.length" class="space-y-2.5">
      <div v-for="community in communities" :key="community.name">
        <div class="tw-flex items-center justify-between text-sm mb-1">
          <span class="text-gray-600 truncate">{{ community.name }}</span>
          <span class="text-gray-400">{{ community.members }}</span>
        </div>
        <div class="h-2 rounded-full bg-gray-100 overflow-hidden">
          <div class="h-full rounded-full bg-primary" :style="{ width: communityWidth(community.members) + '%' }"></div>
        </div>
      </div>
    </div>
    <div v-else class="text-sm text-gray-400 py-2">No communities yet</div>
  </section>
</template>

<script>
  export default {
    name: 'HeartbeatContent',
    props: {
      content: Object,
    },
    computed: {
      communities () {
        return (this.content && this.content.communities) || []
      },
      communitiesMax () {
        return this.communities.reduce((max, community) => Math.max(max, community.members), 0)
      },
    },
    methods: {
      communityWidth (members) {
        if (!this.communitiesMax) {
          return 0
        }

        return Math.max(3, Math.round((members / this.communitiesMax) * 100))
      },
    },
  }
</script>
